import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import adminOrderServices from './admin_order_services';

export const GetOrders = createAsyncThunk(
  'admin_order/get_admin_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.getOrders(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSelectionOrders = createAsyncThunk(
  'admin_order/get_admin_selection_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.getOrders(payload);

      return { ...response, my_selection_order: payload?.my_selection_order };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAdminSingleOrder = createAsyncThunk(
  'admin_order/get_single_admin_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.getSingleAdminOrder(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditAdminOrder = createAsyncThunk(
  'admin_order/edit_admin_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.editAdminOrder(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditAdminSingleOrder = createAsyncThunk(
  'admin_order/edit_admin_single_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.editAdminOrder(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditAdminPaymentOrder = createAsyncThunk(
  'admin_order/edit_admin_payment_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.editAdminPaymentOrder(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAUsersOrders = createAsyncThunk(
  'admin_order/get_a_users_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.getAUsersOrders(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAUserStatusOrders = createAsyncThunk(
  'admin_order/get_a_users_status_order',
  async (payload, thunkAPI) => {
    try {
      let response = await adminOrderServices.getAUsersStatusOrders(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetStatusOrders = createAsyncThunk(
  'admin_order/get_status_order',
  async (_, thunkAPI) => {
    try {
      let response = await adminOrderServices.getStatusOrders();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllCountOrders = createAsyncThunk(
  'admin_order/get_all_count_order',
  async (_, thunkAPI) => {
    try {
      let response = await adminOrderServices.getAllCountOrders();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const SearchForOrdersByName = createAsyncThunk(
  'admin_order/searchForOrdersByName',
  async (payload, thunkAPI) => {
    try {
      const delivered = await adminOrderServices.SearchForOrderByName(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
